// @flow
import React, { Component } from 'react';

import BrightnessPicker from '../standard-brightness-picker';
import { BulbFlipperWrapper } from '../styles';
import ColorPicker from '~/components/widgets/flipper/rgb-flipper';
import DimmerMenu from './dimmer-menu';
import { MenuContainer } from '../menu';
import type { MenuInsertions } from '~/core/types';
import { noop } from 'lodash/fp';
import PickerMenu from './picker-menu';
import temperatureColorScaleImage from '~/assets/images/tone-picker-white.png';

type Props = {
    additionalMenuItems: MenuInsertions,
    bulbBrightness: number,
    bulbColorMode?: string,
    bulbType?: string,
    changeColor?: noop,
    debug?: boolean,
    delayRendering?: number,
    handleRadiusPercent?: number,
    isOn: boolean,
    isSaving?: boolean,
    isSmall: boolean,
    isToggling?: boolean,
    logger?: noop,
    pickerDepthPercent?: number,
    productId?: string,
    rangeValue?: number,
    rgb?: Uint8ClampedArray,
    toggleLightbulb: noop,
    valueChanged: noop
};

type State = {
    showBrightnessPicker: boolean
};

class ColorTuneable extends Component<Props, State> {
    state = {
        showBrightnessPicker: false
    };

    switchComponent(showBrightnessPicker: boolean) {
        this.setState({
            showBrightnessPicker
        });
    }

    switchPicker() {
        this.setState({
            showBrightnessPicker: false
        });
    }

    render() {
        const {
            isOn,
            isSaving,
            isToggling,
            toggleLightbulb,
            bulbBrightness,
            valueChanged,
            productId,
            delayRendering,
            rgb,
            rangeValue,
            bulbType,
            handleRadiusPercent = 5,
            pickerDepthPercent = 5,
            changeColor,
            debug,
            logger,
            isSmall,
            additionalMenuItems
        } = this.props;

        const { showBrightnessPicker } = this.state;

        return (
            <BulbFlipperWrapper>
                {showBrightnessPicker ? (
                    <BrightnessPicker
                        isOn={isOn}
                        isSaving={isSaving}
                        isSmall={isSmall}
                        isToggling={isToggling}
                        toggleLightbulb={toggleLightbulb}
                        value={bulbBrightness}
                        valueChanged={valueChanged}
                    />
                ) : (
                    <ColorPicker
                        bulbBrightness={bulbBrightness}
                        bulbType={bulbType}
                        changeColor={changeColor}
                        colourStartRadians={3.52}
                        colourStopRadians={5.9}
                        debug={debug}
                        delayRendering={delayRendering}
                        handleRadiusPercent={handleRadiusPercent}
                        image={temperatureColorScaleImage}
                        isCustomRange
                        isOn={isOn}
                        isSaving={isSaving}
                        isSmall={isSmall}
                        isToggling={isToggling}
                        logger={logger}
                        pickerDepthPercent={pickerDepthPercent}
                        productId={productId}
                        rangeValue={rangeValue}
                        rgb={rgb}
                        toggleLightbulb={toggleLightbulb}
                    />
                )}

                <MenuContainer isSmall={isSmall}>
                    {showBrightnessPicker ? (
                        <DimmerMenu
                            additionalItems={additionalMenuItems}
                            isOn={isOn}
                            onClick={() => this.switchComponent(!showBrightnessPicker)}
                        />
                    ) : (
                        <PickerMenu
                            additionalItems={additionalMenuItems}
                            isOn={isOn}
                            toggleDimmer={() => this.switchComponent(!showBrightnessPicker)}
                        />
                    )}
                </MenuContainer>
            </BulbFlipperWrapper>
        );
    }
}

export default ColorTuneable;



// WEBPACK FOOTER //
// ./src/components/bulbs/tuneablelight/index.js